import $fn from '@/utils/fn';
export default {
    namespaced: true,
    state: {
        names: "首页",
        baseUrl: ""
    },
    // getters:{},
    mutations: {},
    actions: {}
}
